// extracted by mini-css-extract-plugin
export default {"after-action-close-icon":"ImageView_after-action-close-icon_RmcIE","img-tips-wrapper":"ImageView_img-tips-wrapper_K8z_M"};